import React, {
  useState,
  useImperativeHandle,
  ForwardRefRenderFunction,
  forwardRef,
  ReactNode,
} from "react";
import ImageUploading, { ImageListType } from "react-images-uploading";

import Compress from "browser-image-compression";

import { MultipleContainer, ButtonsWrapper, StyledButton } from "./styles";

type ImageUploadProps = {
  setImgs(imgs: string[]): void;
  children?: ReactNode | (Element & ReactNode);
  customChild: boolean;
};

export type MultipleHandles = {
  handleClearImgs: () => void;
};

const Multiple: ForwardRefRenderFunction<MultipleHandles, ImageUploadProps> = (
  { setImgs },
  ref
) => {
  const [images, setImages] = useState<ImageListType>([]);

  const handleClearImgs = (): void => {
    setImages([]);
  };

  useImperativeHandle(ref, () => ({
    handleClearImgs,
  }));

  const getBase64 = (file: File, options: any): any =>
    new Promise((resolve, reject) => {
      Compress(file, options).then((compressedBlob) => {
        const convertedBlobFile = new File([compressedBlob], file.name, {
          type: file.type,
          lastModified: Date.now(),
        });
        const reader = new FileReader();

        reader.readAsDataURL(convertedBlobFile);
        reader.onerror = reject;
        reader.onload = () => {
          resolve(reader.result);
        };
      });
    });

  const onChange = (imageList: ImageListType): void => {
    const options = {
      maxSizeMB: 1,
      useWebWorker: true,
    };

    if (imageList.length > 0 && imageList[0].file) {
      getBase64(imageList[0].file, options).then((result: string) => {
        const [, formatedBase64Url] = result.split("base64,");

        setImgs([formatedBase64Url]);
      });
    }
    setImages(imageList as never[]);
  };

  return (
    <ImageUploading value={images} onChange={onChange}>
      {({
        imageList,
        onImageUpload,
        onImageRemoveAll,
        isDragging,
        dragProps,
      }) => (
        <MultipleContainer>
          <ButtonsWrapper hasImage={imageList.length > 0}>
            <StyledButton
              style={isDragging ? { color: "red" } : undefined}
              onClick={() => {
                onImageRemoveAll();
                onImageUpload();
              }}
              type="button"
              className="photo"
              {...dragProps}
            >
              {images.length > 0 ? (
                images.map((img) => (
                  <img
                    src={img.dataURL ?? ""}
                    width={40}
                    height={40}
                    className="mini-img"
                    key={img.file?.name}
                    alt={img.file?.name}
                  />
                ))
              ) : (
                <>
                  ENVIAR IMAGEM
                  <img
                    src="/assets/svgs/foto.svg"
                    width={20}
                    height={20}
                    className="icon"
                    alt="img icon"
                  />
                </>
              )}
            </StyledButton>
          </ButtonsWrapper>
        </MultipleContainer>
      )}
    </ImageUploading>
  );
};

export default forwardRef(Multiple);
